// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"eE","blender_bottle_img":"fE","blender_bottle_info":"gE","blender_bottle_title":"hE","blender_bottle_bold":"iE","blender_bottle_usual":"jE","blender_bottle_item_mob":"kE","addbutton":"lE","blender_bottle_title_mob":"mE","blender_bottle_bold_mob":"nE","blender_bottle_usual_mob":"oE","bolder":"pE","bottom_margin_4":"qE","bottom_margin_16":"rE"};
    if(module.hot) {
      // 1713211520713
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  